export const paddingHorizontal = "px-5 md:px-10 lg:px-14 xl:px-20";
